module.exports = __webpack_public_path__ + "img/a65.1a3dad49.png";